import { useEffect, useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import axios from "axios";
import { Button } from "../components/ui/button";
import { CheckCircle2, XCircle, Loader2 } from "lucide-react";

const API_BASE = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function ApproveWorkspace() {
  const [search] = useSearchParams();
  const nav = useNavigate();
  const token = search.get("token");
  const [state, setState] = useState("working"); // working | done | error
  const [company, setCompany] = useState("");
  const [error, setError] = useState("");

  useEffect(() => {
    if (!token) {
      setState("error");
      setError("Missing token");
      return;
    }
    // Call directly (unauthenticated endpoint)
    axios.get(`${API_BASE}/admin/workspaces/approve-link`, { params: { token } })
      .then((r) => {
        setCompany(r.data.company_name || "Workspace");
        setState("done");
      })
      .catch((e) => {
        setError(e?.response?.data?.detail || "Approval failed");
        setState("error");
      });
  }, [token]);

  return (
    <div className="min-h-screen grid place-items-center p-6 bg-slate-50">
      <div className="w-full max-w-md bg-white rounded-lg border border-slate-200 shadow-sm p-8 text-center" data-testid="approve-page">
        {state === "working" && (
          <>
            <Loader2 className="mx-auto text-slate-500 animate-spin" size={44} />
            <h1 className="mt-4 text-lg font-semibold text-slate-900">Approving workspace…</h1>
          </>
        )}
        {state === "done" && (
          <>
            <CheckCircle2 className="mx-auto text-emerald-600" size={48} />
            <h1 className="mt-4 text-xl font-semibold text-slate-900">Workspace approved</h1>
            <p className="mt-2 text-sm text-slate-600">
              <strong>{company}</strong> can now sign in and start their 14-day free trial.
            </p>
            <Button className="mt-6 w-full bg-blue-600 hover:bg-blue-700 text-white" onClick={() => nav("/home")} data-testid="approve-done-btn">
              Done
            </Button>
          </>
        )}
        {state === "error" && (
          <>
            <XCircle className="mx-auto text-rose-600" size={48} />
            <h1 className="mt-4 text-xl font-semibold text-slate-900">Could not approve</h1>
            <p className="mt-2 text-sm text-slate-600">{error}</p>
            <p className="mt-2 text-xs text-slate-500">
              The link may have expired. Sign in as super-admin to approve manually.
            </p>
            <Button className="mt-6 w-full bg-blue-600 hover:bg-blue-700 text-white" onClick={() => nav("/login")} data-testid="approve-signin-btn">
              Go to sign in
            </Button>
          </>
        )}
      </div>
    </div>
  );
}
